<template>
  <vk-modal :has-close-icon="closeIcon" @close="$emit('close')">
    <vk-modal-body>
      <vk-modal-header :class="{closeIcon: 'p-l-6'}" class="text-bold">
        Review for {{ review.proName }}
      </vk-modal-header>
      <vk-modal-content>
        <div class="m-x-4:t m-b-4">
          <div class="OVERALL-RATING">
            <div
                v-for="(label, index) in $options.REVIEW_LABELS"
                :key="index"
                :class="['STAR', 'flex-1-1', 'm-0', {
                  'PRESELECTED': index + 1 < review.overall_rating,
                  'SELECTED': index + 1 === review.overall_rating,
                }]"
                @click="onRatingClick((index + 1), 'overall')">
              <vk-icon name="star" class="STAR-ICON" />
              <span class="STAR-LABEL">{{ label }}</span>
            </div>
          </div>

          <div class="m-b-4">
            <p class="COMMENTS m-b-1 p-l-1" selenium="see-review-comments">
              {{ review.review_comments }}
            </p>
            <div class="text-md text-bold p-l-1" selenium="customer-name">{{ userFullName }}</div>
          </div>

          <div v-if="review.assets" class="m-b-4">
            <gallery :files="review.assets"/>
            <p
                class="p-t-2 text-sm">
              {{review.assets.length}} {{ review.assets.length === 1? 'photo' : 'photos'}} added
            </p>
          </div>

          <div class="CATEGORIES" v-if="review.category_rating">
            <review-categories :categories="review.category_rating" />
          </div>

        </div>
      </vk-modal-content>
    </vk-modal-body>
  </vk-modal>
</template>

<script>

import { REVIEW_LABELS } from '@/constants/reviews';
import ReviewCategories from '@/components/ReviewCategories';
import Gallery from '@/components/Gallery';

export default {
  REVIEW_LABELS,
  name: 'view-review-modal',
  components: {
    ReviewCategories,
    Gallery,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
    closeIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    userFullName () {
      return this.review.is_anonymous
        ? 'Proreferral Customer'
        : `- ${this.review.customer.first_name} ${this.review.customer.last_name}`;
    },
  },
};
</script>
<style lang="scss" scoped>
 @import "~@homeservices/design-kit/tools";

  $transition-half-duration: 0.15s;
  .OVERALL-RATING {
    display: flex;
    margin: 3*$unit auto 2*$unit 0;
    max-width: 250px;
  }
  .STAR {
    @include text-small;
    @include margin(0 0.5, 0 3);
    display: flex;
    flex-direction: column;
    width: 50px;
    align-items: center;
    color: $color-gray70;
    transition: font-weight $transition-half-duration;
    &.SELECTED {
      font-weight: 700;
    }
    &.PRESELECTED,
    &.SELECTED  {
      .STAR-ICON {
        color: $color-depot;
      }
    }
    .STAR-ICON {
      @include h4;
      margin-bottom: $unit;
    }
    .STAR-LABEL{
      font-size: 10px;
    }
    @include tablet {
      @include h6;
    }
  }

  .COMMENTS {
    border-left: 4px solid lightgray;
  }

  .CATEGORIES {
    max-width: 300px;
  }

</style>
